import { useCentralStore } from "../../store/appContext"
import resources from '../../components/common/resources.json'
import HomeIcon from '../../assets/icons/home-icon'
import ActionTypes from "../../store/actionTypes";
import API from "../../api";
import moment from "moment";
import InfoIcon from '../../assets/icons/infoIcon';
import DownloadIcon from '../../assets/icons/downloadIcon';
import { getCarrierByDomain } from "../../domain";

const SHDashboardMenu = ({ prevMonth }) => {

    const [ { reportFilterDuration, selectedTab, userData, userDetails, projectSHSubMenu, carrierThemeData }, dispatch ] = useCentralStore()
    const { theme } = carrierThemeData;

    const setLoading = (action) => {
        dispatch({ type: ActionTypes.SET_LOADING, payload: action });
      };

    const handleBPMClick = () => {
        dispatch({
          type: ActionTypes.SET_PROJECT_NAME,
          payload: null,
        });
        dispatch({ type: ActionTypes.SET_SELECTED_TAB, payload: null });
        dispatch({ type: ActionTypes.SET_PROGRAM_NAME, data: "" });
        dispatch({ type: ActionTypes.SGP_SET_REPORT_FILTER_DURATION, payload: {
          type: null,
          startDate: null,
          endDate: null,
          duration: null
        }})
        
        dispatch({ type: ActionTypes.GET_STARHUB_REPORT_COUNT_SUCCESS, payload: null})
        dispatch({ type: ActionTypes.GET_STARHUB_REPORT_COUNT_DETAILS_SUCCESS, payload: null})
        dispatch({ type: ActionTypes.GET_STARHUB_REPORT_DETAILS_SUCCESS, payload: null})
    
        dispatch({ type: ActionTypes.SGP_SET_REPORT_FILTER, payload: 'real time'})
      };

      const handleMonthlyTrendData = () => {
          let payload = {
            idToken: userData?.access_token,
          };

          setLoading(true);
          API[ActionTypes.GET_CHART_COUNT_DATA](payload, userDetails && userDetails?.email?.split("@")?.[0])
            .then(({ data }) => {
                setLoading(false);
                if (data) {
                dispatch({
                    type: ActionTypes.GET_CHART_COUNT_DATA_SUCCESS,
                    payload: data,
                });
                }
            })
            .catch((err) => {
                dispatch({
                type: ActionTypes.GET_CHART_COUNT_DATA_FAILURE,
                payload: err,
                });
            dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
            let _payload = {
            level: resources.POST_LOGGER_ERROR,
            category: resources.POST_LOGGER_API,
            ApiName: resources.POST_LOGGER_APINAME,
            message: {
                error: err,
                info: {
                idToken: "",
                },
            },
            };
            API[ActionTypes.POST_LOGGER](_payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
        });
          
      }

      const handleRealTimeTab = (val, parentLabel) => {
        dispatch({
          type: ActionTypes.SET_SELECTED_TAB,
          payload: val,
        })
        dispatch({ type: ActionTypes.SGP_SET_REPORT_FILTER, payload: 'real time'})
        
        if(val === 'Real Time' && parentLabel === 'Real Time Service Request Report') {
          let startDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format('YYYY-MM-DD 00:00:00')
          let endDate = moment(new Date()).format('YYYY-MM-DD 23:59:59')
      
          dispatch({ type: ActionTypes.SGP_SET_REPORT_FILTER_DURATION, payload: {
              type: 'dates',
              startDate: startDate,
              endDate: endDate,
              duration: 'dates'
          }})
          dispatch({
              type: ActionTypes.HIDE_DATE_FILTER,
              payload: false,
          })
        }

        if(val === 'Monthly Trends' && (parentLabel === 'Real Time Service Request Report' || parentLabel === 'Customer Service SLA Report' || parentLabel === 'Technical Service SLA Report')) handleMonthlyTrendData()
      }

      const dynamicStyle = {
        '--border-b-color': theme?.colors?.primary,
        '--border-color': theme?.colors?.primary,
        '--background-color': theme?.colors?.primary,
    };

    return(
      <div className="flex justify-between">
        <div className="flex">
          {/* <div className={`cursor-pointer py-0 pr-3 pl-1 flex justify-center items-center borderBottomStyle mr-5 ${selectedTab === 'HomePage' ? "backgroundStyle font-bold rounded-lg" : ""}`}
            style={dynamicStyle}>
            <div className="flex items-center" onClick={() => handleBPMClick()}>
              <HomeIcon className="" fill={selectedTab === 'HomePage' ? "black" : theme?.colors?.primary}
              />
              <div className={`text-black text-xs`}>
                Home
              </div>
            </div>
          </div> */}

          {projectSHSubMenu && projectSHSubMenu?.subLabels?.map(v =>
            <div className={`font-bold cursor-pointer p-3 flex justify-center items-center mr-5 ${selectedTab === v?.value ? "backgroundStyle borderBottomStyle font-bold rounded-t-lg" : "borderStyle rounded-t-lg"}`} style={dynamicStyle}>
              <div className={`${selectedTab === v?.value ? 'mt-1' : ''} flex items-center mr-2`} onClick={() => handleRealTimeTab(v?.value, v?.parentLabel)} >
                {v?.value === 'DownloadReport' ? <DownloadIcon className="w-5 h-5" fill={selectedTab === v?.value ? "black" : '#1ED760'} /> :
                  // v?.value === "Glossary" ? <InfoIcon className="flex w-3 h-3" fill={selectedTab === v?.value ? "white" : theme?.colors?.primary} /> :
                    <></>
                }
                <div className={`text-xs ml-1 ${getCarrierByDomain() === 'Celcom' && selectedTab === v?.value ? 'text-white' : 'text-black'}`}> {/* ${selectedTab === v?.value ? '' : 'mt-[-4px]'}  */}
                  {v?.label?.includes('Program Summary') ? prevMonth : v?.label?.includes('Prev') ? v?.label?.replace('Prev', reportFilterDuration?.duration) : v?.label}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
}

export default SHDashboardMenu